// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white-hex: #ffffffff;
  --glaucous-hex: #7489bbff;
  --antiflash-white-hex: #f4f4f5ff;
  --isabelline-hex: #efedecff;
  --white-2-hex: #ffffffff;
  --white-3-hex: #ffffffff;
  --jordy-blue-hex: #8bb4eeff;
  --lavender-web-hex: #d1dae7ff;
  --white-4-hex: #fefefeff;
  --cadet-gray-hex: #9faebeff;

  /* CSS HSL */
  --white-hsl: rgba(255, 255, 255, 0.309);
  --glaucous-hsl: rgba(115, 136, 186, 0.391);
  --antiflash-white-hsl: hsla(240, 5%, 96%, 1);
  --isabelline-hsl: hsla(20, 9%, 93%, 1);
  --white-2-hsl: hsla(0, 0%, 100%, 1);
  --white-3-hsl: hsla(0, 0%, 100%, 1);
  --jordy-blue-hsl: hsla(215, 74%, 74%, 1);
  --lavender-web-hsl: hsla(215, 31%, 86%, 1);
  --white-4-hsl: hsla(0, 0%, 100%, 1);
  --cadet-gray-hsl: hsla(211, 19%, 68%, 1);
}

html {
  overflow-y: scroll;
  scrollbar-gutter: stable;
}

.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #1f89c2;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}

.loader-container {
  display: flex;
  justify-content: center; 
  align-items: center; 
  position: fixed; 
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; 
}

/* HTML: <div class="loader"></div> */
.loaderNature {
  width: 80px;
  height: 40px;
  border-radius: 100px 100px 0 0;
  background: linear-gradient(0deg, #0000, #FFFFFF, #0000) 70% 30%, linear-gradient(90deg, #0000, #FFFFFF, #0000) 72% 32%, linear-gradient(0deg, #0000, #FFFFFF, #0000) 26% 42%,
    linear-gradient(90deg, #0000, #FFFFFF, #0000) 23% 44%, linear-gradient(0deg, #0000, #FFFFFF, #0000) 51% 54%, linear-gradient(90deg, #0000, #FFFFFF, #0000) 51% 53% #020308;
  background: linear-gradient(0deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 70% 30%, linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 72% 32%, linear-gradient(0deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 26% 42%,
    linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 23% 44%, linear-gradient(0deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 51% 54%, linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 51% 53% #020308;
  background-size: 2px 10px, 10px 2px;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}
.loaderNature:before,
.loaderNature:after {
  content: "";
  position: absolute;
  inset: 100% auto auto 20px;
  height: 3px;
  width: 20px;
  background: linear-gradient(90deg, #0000, #FFFFFF);
  background: linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF));
  transform-origin: right;
  transform: rotate(-20deg) translate(-20px);
  animation: l6 2s infinite;
}
.loaderNature:after {
  inset: 100% auto auto -5px;
  animation-delay: 0.75s;
}
@keyframes l6 {
  100% {
    transform: rotate(-20deg) translate(120px);
  }
}

/* HTML: <div class="loader"></div> */
.loaderClassic {
  width: -webkit-fit-content;
  width: fit-content;
  font-weight: bold;
  font-family: sans-serif;
  font-size: 30px;
  padding-bottom: 8px;
  background: linear-gradient(currentColor 0 0) 0 100%/0% 3px no-repeat;
  animation: l2 2s linear infinite;
}
.loaderClassic:before {
  content: "Loading...";
}
@keyframes l2 {
  to {
    background-size: 100% 3px;
  }
}

/* HTML: <div class="loader"></div> */
.loaderSquare {
  --c: no-repeat linear-gradient(rgb(251, 142, 0) 0 0);
  background: var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c);
  background-size: 16px 16px;
  animation: l32-1 1s infinite, l32-2 1s infinite;
}
@keyframes l32-1 {
  0%,
  100% {
    width: 45px;
    height: 45px;
  }
  35%,
  65% {
    width: 65px;
    height: 65px;
  }
}
@keyframes l32-2 {
  0%,
  40% {
    background-position: 0 0, 0 50%, 0 100%, 50% 100%, 100% 100%, 100% 50%, 100% 0, 50% 0, 50% 50%;
  }
  60%,
  100% {
    background-position: 0 50%, 0 100%, 50% 100%, 100% 100%, 100% 50%, 100% 0, 50% 0, 0 0, 50% 50%;
  }
}

.loaderContent {
  max-width: 100%; /* Establece un ancho máximo para el contenido */
  overflow-x: hidden; /* Oculta el desbordamiento horizontal */
}

.loaderDialog {
  overflow-x: hidden; /* Oculta el desbordamiento horizontal en el diálogo */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;;EAE3B,YAAY;EACZ,uCAAuC;EACvC,0CAA0C;EAC1C,4CAA4C;EAC5C,sCAAsC;EACtC,mCAAmC;EACnC,mCAAmC;EACnC,wCAAwC;EACxC,0CAA0C;EAC1C,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,4EAA4E;EAC5E,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B;8KACoP;EADpP;sPACoP;EACpP,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,WAAW;EACX,kDAA0E;EAA1E,0EAA0E;EAC1E,uBAAuB;EACvB,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE;IACE,0CAA0C;EAC5C;AACF;;AAEA,qCAAqC;AACrC;EACE,0BAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,qEAAqE;EACrE,gCAAgC;AAClC;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,qCAAqC;AACrC;EACE,oDAAoD;EACpD,oGAAoG;EACpG,0BAA0B;EAC1B,+CAA+C;AACjD;AACA;EACE;;IAEE,WAAW;IACX,YAAY;EACd;EACA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;;IAEE,8FAA8F;EAChG;EACA;;IAEE,8FAA8F;EAChG;AACF;;AAEA;EACE,eAAe,EAAE,gDAAgD;EACjE,kBAAkB,EAAE,wCAAwC;AAC9D;;AAEA;EACE,kBAAkB,EAAE,sDAAsD;AAC5E","sourcesContent":[":root {\n  --white-hex: #ffffffff;\n  --glaucous-hex: #7489bbff;\n  --antiflash-white-hex: #f4f4f5ff;\n  --isabelline-hex: #efedecff;\n  --white-2-hex: #ffffffff;\n  --white-3-hex: #ffffffff;\n  --jordy-blue-hex: #8bb4eeff;\n  --lavender-web-hex: #d1dae7ff;\n  --white-4-hex: #fefefeff;\n  --cadet-gray-hex: #9faebeff;\n\n  /* CSS HSL */\n  --white-hsl: rgba(255, 255, 255, 0.309);\n  --glaucous-hsl: rgba(115, 136, 186, 0.391);\n  --antiflash-white-hsl: hsla(240, 5%, 96%, 1);\n  --isabelline-hsl: hsla(20, 9%, 93%, 1);\n  --white-2-hsl: hsla(0, 0%, 100%, 1);\n  --white-3-hsl: hsla(0, 0%, 100%, 1);\n  --jordy-blue-hsl: hsla(215, 74%, 74%, 1);\n  --lavender-web-hsl: hsla(215, 31%, 86%, 1);\n  --white-4-hsl: hsla(0, 0%, 100%, 1);\n  --cadet-gray-hsl: hsla(211, 19%, 68%, 1);\n}\n\nhtml {\n  overflow-y: scroll;\n  scrollbar-gutter: stable;\n}\n\n.loader {\n  width: 50px;\n  padding: 8px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: #1f89c2;\n  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;\n  -webkit-mask: var(--_m);\n  mask: var(--_m);\n  -webkit-mask-composite: source-out;\n  mask-composite: subtract;\n  animation: l3 1s infinite linear;\n}\n@keyframes l3 {\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n.loader-container {\n  display: flex;\n  justify-content: center; \n  align-items: center; \n  position: fixed; \n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 9999; \n}\n\n/* HTML: <div class=\"loader\"></div> */\n.loaderNature {\n  width: 80px;\n  height: 40px;\n  border-radius: 100px 100px 0 0;\n  background: linear-gradient(0deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 70% 30%, linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 72% 32%, linear-gradient(0deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 26% 42%,\n    linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 23% 44%, linear-gradient(0deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 51% 54%, linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF), #0000) 51% 53% #020308;\n  background-size: 2px 10px, 10px 2px;\n  background-repeat: no-repeat;\n  position: relative;\n  overflow: hidden;\n}\n.loaderNature:before,\n.loaderNature:after {\n  content: \"\";\n  position: absolute;\n  inset: 100% auto auto 20px;\n  height: 3px;\n  width: 20px;\n  background: linear-gradient(90deg, #0000, var(--fx-surface-base, #FFFFFF));\n  transform-origin: right;\n  transform: rotate(-20deg) translate(-20px);\n  animation: l6 2s infinite;\n}\n.loaderNature:after {\n  inset: 100% auto auto -5px;\n  animation-delay: 0.75s;\n}\n@keyframes l6 {\n  100% {\n    transform: rotate(-20deg) translate(120px);\n  }\n}\n\n/* HTML: <div class=\"loader\"></div> */\n.loaderClassic {\n  width: fit-content;\n  font-weight: bold;\n  font-family: sans-serif;\n  font-size: 30px;\n  padding-bottom: 8px;\n  background: linear-gradient(currentColor 0 0) 0 100%/0% 3px no-repeat;\n  animation: l2 2s linear infinite;\n}\n.loaderClassic:before {\n  content: \"Loading...\";\n}\n@keyframes l2 {\n  to {\n    background-size: 100% 3px;\n  }\n}\n\n/* HTML: <div class=\"loader\"></div> */\n.loaderSquare {\n  --c: no-repeat linear-gradient(rgb(251, 142, 0) 0 0);\n  background: var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c), var(--c);\n  background-size: 16px 16px;\n  animation: l32-1 1s infinite, l32-2 1s infinite;\n}\n@keyframes l32-1 {\n  0%,\n  100% {\n    width: 45px;\n    height: 45px;\n  }\n  35%,\n  65% {\n    width: 65px;\n    height: 65px;\n  }\n}\n@keyframes l32-2 {\n  0%,\n  40% {\n    background-position: 0 0, 0 50%, 0 100%, 50% 100%, 100% 100%, 100% 50%, 100% 0, 50% 0, 50% 50%;\n  }\n  60%,\n  100% {\n    background-position: 0 50%, 0 100%, 50% 100%, 100% 100%, 100% 50%, 100% 0, 50% 0, 0 0, 50% 50%;\n  }\n}\n\n.loaderContent {\n  max-width: 100%; /* Establece un ancho máximo para el contenido */\n  overflow-x: hidden; /* Oculta el desbordamiento horizontal */\n}\n\n.loaderDialog {\n  overflow-x: hidden; /* Oculta el desbordamiento horizontal en el diálogo */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
